module.exports = __webpack_public_path__ + "img/halon_yes.490f6529.png";